<template>
  <b-container fluid>
    
    <div class="d-flex align-items-center">
      <b-button v-show="isOK === true" @click="exportExcel()" variant="outline-secondary" class="mr-3">Descargar</b-button>
      <h2>Datos RCI</h2>
    </div>
    <div class="container-controls">
      <div class="buscarrci">
			<div class="flex mb-3">
  			<select class="form-control" v-model="filterOn"  style="width:auto;">
						<option v-for="campo in campos"> {{ campo }}</option>
				</select>
					<input type="text" placeholder="Filtro 1" class="form-control "  v-model="filtro1" @keyup.enter="filtro1">
			</div>	  
      <div v-if="filtro1" class="flex mb-3">
				<select class="form-control" v-model="filterOn2" style="width:auto;">
					<option v-for="campo in campos"> {{ campo }}</option>
				</select>
				<input type="text" placeholder="Filtro 2" class="form-control "  v-model="filtro2">
			</div>
		  <div v-if="filtro2" class="flex mb-3">
  		  <select class="form-control" v-model="filterOn3" style="width:auto;">
					<option v-for="campo in campos"> {{ campo }}</option>
				</select>
				<input type="text" placeholder="Filtro 3" class="form-control "  v-model="filtro3">
			</div>
		  </div>
      
      <div class="navigation">
        <ul>
			    <li><a v-on:click="set10()" class="btn btn-secondary btn-cantidad">10 registros</a></li>
			    <li><a v-on:click="set50()" class="btn btn-secondary btn-cantidad">50 registros</a></li>
			    <li><a v-on:click="set100()" class="btn btn-secondary btn-cantidad">100 registros</a></li>
          <li><router-link to="/home/ofdatosrci"> <a class="btn btn-ofimpresa" exact to="/home/ofdatosrci">OF Impresa</a> </router-link></li>
			  </ul>
		  </div>
     
      
    </div>
    
   
    <vtable 
      v-if="isWeb == false"  
      :isBusy="isBusy"
      :data='data' 
      :fields='fields' 
      :height="maxWidth(windowWidth)" 
      :perPage="pageSize"
      :currentPage="pageNo"
      
    ></vtable>
    <vtable 
      v-else  
      :data='data' 
      :fields='fields2' 
      :height="maxWidth(windowWidth)" 
      :key="vtkey"
      :perPage="pageSize"
      :currentPage="pageNo"
    >
    </vtable>
   
    <!-- Paginacion -->
    <b-pagination
      v-model="pageNo"
      :total-rows="totalRows"
      :per-page="pageSize"
      align="center" 
      size="sm"
      class="mt-1"
      @change="handlePageChange"
    >
    </b-pagination>      
   </b-container>
</template>

<script>
    import {mapActions, mapState, mapGetters} from 'vuex'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css'
    import moment from 'moment'
    import XLSX from 'xlsx'
    import customMixin from '@/mixins/customMixin'
    import vtable from '@/components/partials/vtable2'

    export default {
        name:'datosrci',
        mixins : [customMixin],
        components:{
            Loading, vtable
        },
        data:function(){
          return{
                data:[],
                totalRows: 0,
                pageNo: 1,
                pageCount: 0,
                pageSize: 100,
               // pageOptions: [10, 50, 100],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                
                filtro1: null,
                filtro2: null,
                filtro3: null,
                filterOn: [],
                filterOn2: [],
                filterOn3: [],
               
                campos:['OF','Descripcion','ESTATUS_OF','NAI','NASN','Cliente'],
                fields: [
                        { key: 'OF',stickyColumn: true, isRowHeader: true, variant: 'primary' },
                        { key: 'Descripcion'},
                        { key: 'ESTATUS_OF' },
                        { key: 'NAI'},
                        { key: 'ESTATUS_NAI'},
	                      { key: 'NASN' },
                      	{ key:'Pedida'},
                      	{ key:'Planificada'},
                      	{ key:'Entregado_PT'},
                      	{ key:'Facturada'},
                      	{ key:'Por_Entregar'},
                      	{ key:'Existencia_PT'},
                      	{ key:'Tarimas_del_Pedido'},
                      	{ key:'Peso_Pedido'},
                      	{ key:'Tarimas_en_PT'},
                      	{ key:'Peso_PT'},
                      	{ key:'Cliente'},
                      	{ key:'OC_SN'},
                      	{ key:'Pedido'},
                      	{ key:'Elaboracion_Pedido'},
                      	{ key:'Fecha_OF'},
                        { key:'Vencimiento'},
                        { key:'Vendedor'},
                        //{ Field:'ID_Vendedor'},
                        { key:'Precio_descuento'},
                      	{ key:'Peso_Pieza'},
                      	{ key:'Unidad_de_Carga'},
                      	{ key:'Corrugado'},
                      	{ key:'Pliegos_a_Imprimir'},
                      	{ key:'Planilla'},
                      	{ key:'Suaje'},
                      	{ key:'Tinta_1'},
                      	{ key:'Tinta_2'},
                      	{ key:'Tinta_3'},
                      	{ key:'Tinta_4'},
                      	{ key:'Tinta_5'},
                      	{ key:'Tinta_6'},
                      	{ key:'Liberacion_MP'}
                ],
                 fields2 : [
                        { key: 'OF',stickyColumn: true, isRowHeader: true, variant: 'primary' },
                        { key: 'Descripcion'},
                        { key: 'ESTATUS_OF' },
                        { key: 'NAI'},
                        { key: 'ESTATUS_NAI'},
	                      { key: 'NASN' },
                      	{ key:'Pedida'},
                      	{ key:'Planificada'},
                      	{ key:'Entregado_PT'},
                      	{ key:'Facturada'},
                      	{ key:'Por_Entregar'},
                      	{ key:'Existencia_PT'},
                      	{ key:'Tarimas_del_Pedido'},
                      	{ key:'Peso_Pedido'},
                      	{ key:'Tarimas_en_PT'},
                      	{ key:'Peso_PT'},
                      	{ key:'Cliente'},
                      	{ key:'OC_SN'},
                      	{ key:'Pedido'},
                      	{ key:'Elaboracion_Pedido'},
                      	{ key:'Fecha_OF'},
                        { key:'Vencimiento'},
                        //{ Field:'Vendedor'},
                        //{ Field:'ID_Vendedor'},
                        //{ Field:'Precio_descuento'},
                      	{ key:'Peso_Pieza'},
                      	{ key:'Unidad_de_Carga'},
                      	{ key:'Corrugado'},
                      	{ key:'Pliegos_a_Imprimir'},
                      	{ key:'Planilla'},
                      	{ key:'Suaje'},
                      	{ key:'Tinta_1'},
                      	{ key:'Tinta_2'},
                      	{ key:'Tinta_3'},
                      	{ key:'Tinta_4'},
                      	{ key:'Tinta_5'},
                      	{ key:'Tinta_6'},
                      	{ key:'Liberacion_MP'}
                ],
                isOK: false, // usado para descargar excel
                isWeb: false, // para la tabla generica
                isBusy:true, 
                vtkey:0

          }
        },
        created(){
         this._fetchPermisos(this.rol_id).then(() => {  
                this.isOK =  this.isSapWebAdmin(this.permiso) //usado para descargar excel
                this.isBusy = true
                if (this.isSapWebAdmin(this.permiso)){ 
                  this._fetchDatosRCI().then(() => {
                    this.init() 
                     
                })
                }else if (this.isSapWeb(this.permiso)){
                  this.isWeb = true
                  this._fetchDatosRCIbyIngenieria().then(() => {
                    this.init() 
                    
                  })
                }else if (this.isSapWebVendedor(this.permiso)){
                  this._fetchDatosRCIbyVendor(this.vsap).then(() =>{
                    this.init() 
                    
                  })
                }
                this.totalRows = this.setTotalRow
               
              })//_fetchPermisos
        },
        mounted(){
           
        },
        updated(){
          //
        },
        watch:{
	      	filtro1: function(){
            if(this.filtro1 == ''){
              this.init()
            }
	      		this.data = this.virtualDataFiltered(this.datosphp,this.filterOn,this.filtro1)
            this.totalRows = this.virtualDataFiltered(this.datosphp,this.filterOn,this.filtro1).length
            
          },
          filtro2: function(){
            this.data = this.virtualDataFiltered(this.data,this.filterOn2,this.filtro2)
            this.totalRows = this.virtualDataFiltered(this.datosphp,this.filterOn2,this.filtro2).length
          },
          filtro3: function(){
            this.data = this.virtualDataFiltered(this.data,this.filterOn3,this.filtro3)
            this.totalRows = this.virtualDataFiltered(this.datosphp,this.filterOn3,this.filtro3).length
          }
	      },
         computed:{
            ...mapState('datosrci',['datosphp','act']),
            ...mapState(['Loading']),
            ...mapGetters('datosrci',['setTotalRow']),
            ...mapState('login',['rol_id','vsap']),
            ...mapState('permiso',['permiso']),  
            ...mapState(['windowWidth']),//llamamos al estado.
            sortOptions() {
             // Create an options list from our fields
             return this.fields
               .filter(f => f.sortable)
               .map(f => {
                 return { text: f.label, value: f.key }
               })
            }
        }, 
        methods:{
            ...mapActions({
                _fetchDatosRCI: 'datosrci/fetchDatosRCI2',
                _fetchPermisos: 'permiso/fetchPermisosUsuarios',
                _fetchDatosRCIbyVendor: 'datosrci/fetchDatosRCIbyVendor2',
                _fetchDatosRCIbyIngenieria: 'datosrci/fetchDatosRCIbyIngenieria2'
            }),
            init(){
              this.data = this.datosphp
              this.isBusy = false
              this.totalRows = this.setTotalRow
              this.filtro3 = null
              this.filtro2 = null
              this.filtro1 = null
            },
            /*
            onFiltered(filteredItems) {
              // Trigger pagination to update the number of buttons/pages due to filtering
              this.totalRows = filteredItems.length
              this.pageNo = 1
            },*/
            moment: function (date) {
		        	return moment(date).format('MMMM Do YYYY, h:mm:ss a')
		          },
		        date: function (date) {
		        	moment(date).format('MMMM Do YYYY, h:mm:ss a')
            },
            exportExcel: function () {
		        	let data = XLSX.utils.json_to_sheet(this.datosphp)
		        	const workbook = XLSX.utils.book_new()
		        	const filename = 'datosRCI'
		        	XLSX.utils.book_append_sheet(workbook, data, filename)
		        	XLSX.writeFile(workbook, `${filename}.xlsx`)
		        },
            set10: function(){
              this.pageSize = 10
              
            },
            set50: function(){
              this.pageSize = 50
              
            },
            set100: function(){
              this.pageSize = 100
              
            },
            
            
            
            /**
             * metodo que utiliza b-paginate para actualizar 
             */
            handlePageChange(value) {
             this.pageNo = value;
             
            },
            
            
        }, //end methods
        filters: {
	        moment: function (date) {
	          return moment(date).format('MMMM Do YYYY, h:mm:ss a');
	        }
	      }
    }
</script>

<style lang="scss">

  .margin-left-1{
		margin-left:1%;
  }
  .flex {
    display: flex;
  }
  .form-control{
    width: 300px;
    height: 36px;
  }
  .navigation {
	   display: flex;
	   justify-content: space-evenly;
     flex-wrap: wrap;
     
   }
  .navigation ul {
	   display: flex;
	   flex-wrap: wrap;
	   list-style: none;
    
   }
  .navigation ul a{
	  margin-right: 5px;
   
  }
  .vtable{
    padding:0;
    margin:0;
  }
  .btn-ofimpresa{
    background-color: #00ac89;
    color: white;
    margin-left:1em;
  }
  .container-controls{
    display:flex;
    flex-direction: row;

  }

  @media screen and (max-width: 576px){
      .container-controls{
        flex-direction: column;
      }
      .navigation {
	      display: flex;
	    
        flex-wrap: nowrap; 
    }
    .btn-cantidad{
      margin-bottom:1%;
      margin-top:1%;
    }
    .btn-ofimpresa{
      margin-left:0;

    }
  }
</style>